import { iIconProps } from '../icon';

export default function CheckIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 40 40' {...props}>
            <path d='M30.1674 9.57806L13.9475 25.798L5.20892 17.0594C4.82567 17.4422 4.52164 17.8969 4.3142 18.3972C4.10677 18.8976 4 19.434 4 19.9757C4 20.5174 4.10677 21.0538 4.3142 21.5542C4.52164 22.0546 4.82567 22.5092 5.20892 22.892L13.9475 31.6306L36 9.57806C35.6172 9.19481 35.1626 8.89078 34.6622 8.68335C34.1618 8.47591 33.6254 8.36914 33.0837 8.36914C32.542 8.36914 32.0056 8.47591 31.5052 8.68335C31.0048 8.89078 30.5502 9.19481 30.1674 9.57806Z' />
        </svg>
    );
}
